import accountInfo from '../../views/user-info/account-info.vue';
import merchantInfo from '../../views/user-info/merchant-info.vue';
var loginRouter = [
    {
        name: 'accountInfo',
        path: 'account-info',
        component: accountInfo,
    },
    {
        name: 'businessInfo',
        path: 'merchant-info',
        component: merchantInfo,
    },
];
export default loginRouter;
